// extracted by mini-css-extract-plugin
var _1 = "ListAttachedTags-moduleListAttachedTags__DmYL0";
export { _1 as "ListAttachedTags" }
